import { useRegisterSW } from "virtual:pwa-register/solid"
import type { JSX } from "solid-js"

// Registers the self-destroying service worker so that clients
// that previously installed the PWA service worker get it uninstalled.
// Can be removed once all clients have been updated.
export function SWProvider(props: { children: JSX.Element }) {
  useRegisterSW({ immediate: true })
  return <>{props.children}</>
}
